// Bonworld Family Office — i18n translations
// Full translations for EN/DE/FR/ZH covering nav, hero, footer, page headers,
// cookie banner, contact form labels, and section headings.
// Long body content on legal & content pages remains in English.

export const languages = [
  { code: "en", label: "EN", full: "English" },
  { code: "de", label: "DE", full: "Deutsch" },
  { code: "fr", label: "FR", full: "Français" },
  { code: "zh", label: "中", full: "中文" },
];

export const translations = {
  en: {
    "nav.home": "Home",
    "nav.about": "About",
    "nav.philosophy": "Philosophy",
    "nav.services": "Services",
    "nav.team": "Team",
    "nav.insights": "Insights",
    "nav.contact": "Contact",
    "nav.portal": "Client Portal",
    "nav.cta": "Private Consultation",

    "home.eyebrow": "Singapore · Est. 2022 · UEN 202213354N",
    "home.headline1": "Preserving wealth",
    "home.headline2": "across generations.",
    "home.sublinePre": "Bonworld is a private, invitation-only family office headquartered at Peninsula Plaza, Singapore. Since 2022 we have held the mandate of a small number of principal families — stewarding over ",
    "home.sublinePost": " of advised capital with the patience of an heir, not the impatience of a manager.",
    "home.aum": "S$2.1 billion",
    "home.cta1": "Request an Introduction",
    "home.cta2": "Our Philosophy",
    "home.badgeLeft": "111 North Bridge Road · #15-02",
    "home.badgeRight": "Established for the few · Not for the many",

    "home.stat0Val": "S$2.1B+",
    "home.stat0Label": "Advised family capital under stewardship",
    "home.stat1Val": "12",
    "home.stat1Label": "Principal families across three continents",
    "home.stat2Val": "2022",
    "home.stat2Label": "Year of foundation in Singapore",
    "home.stat3Val": "8",
    "home.stat3Label": "Partners & senior professionals",

    "home.pillarsEyebrow": "Four Pillars",
    "home.pillarsTitle": "The quiet architecture of enduring wealth.",
    "home.pillarsLede": "We do not chase indices. We do not sell products. Our craft is the coordinated deployment of capital, structure and counsel — over decades, not quarters.",
    "home.pillar1Title": "Preservation",
    "home.pillar1Text": "Capital defence is the first mandate. Volatility is managed, drawdowns are contained, and generational purchasing power is protected.",
    "home.pillar2Title": "Direction",
    "home.pillar2Text": "A single, disciplined investment committee sets a coherent course across public markets, private assets and real estate.",
    "home.pillar3Title": "Governance",
    "home.pillar3Text": "Structures, trusts and family constitutions engineered for continuity — quiet architecture that outlives cycles.",
    "home.pillar4Title": "Family",
    "home.pillar4Text": "We serve the human ambitions behind the wealth: education of heirs, philanthropy, and legacy in its truest form.",

    "home.networkEyebrow": "Custodial & Manager Network",
    "home.networkTitle": "Institutional relationships behind every allocation.",
    "home.networkLede": "Bonworld operates on open architecture. Assets are held at tier-one custodians in the family's own name; capital is deployed with institutional managers on institutional terms.",

    "home.noteEyebrow": "A Note",
    "home.quote": "A family office is not measured by the return it delivered last year, but by the family it delivers three generations from now.",
    "home.quoteAttrib": "— Founding Charter, Bonworld · Singapore · 2022",

    "home.ctaEyebrow": "A Conversation",
    "home.ctaTitle": "If your family is considering a dedicated office, we would be honoured to meet.",
    "home.ctaBtn": "Request a Private Meeting",

    "footer.tagline": "A single-family, multi-generation office stewarding capital, governance and legacy for a select circle of principal families.",
    "footer.uenLine": "UEN 202213354N · Established 2022",
    "footer.office": "Office",
    "footer.byAppointment": "By appointment only",
    "footer.navigate": "Navigate",
    "footer.legal": "Legal",
    "footer.motto": "Discretion · Stewardship · Continuity",
    "footer.rights": "All rights reserved.",

    "cookie.eyebrow": "A note on cookies",
    "cookie.text": "We use a minimum of cookies to keep this site secure and to understand its health. No advertising. No cross-site tracking. See our",
    "cookie.link": "Cookies Policy",
    "cookie.accept": "Accept",
    "cookie.essential": "Essential only",

    "page.about.eyebrow": "About the House",
    "page.about.title": "A house built for the long horizon.",
    "page.about.lede": "Founded in Singapore in 2022, Bonworld was built on a single conviction: that the best steward of a family's capital is a firm that answers to that family alone. Our mandate is narrow by design and deep by discipline.",

    "page.philosophy.eyebrow": "Investment Philosophy",
    "page.philosophy.title": "How we think, before how we invest.",
    "page.philosophy.lede": "Our philosophy is a compact — six principles that pre-date any portfolio decision, and that govern every one that follows.",

    "page.services.eyebrow": "Services",
    "page.services.title": "A single mandate. Six coordinated disciplines.",
    "page.services.lede": "We do not sell modules. We provide one integrated service — the family office — expressed through six disciplines that reinforce one another.",

    "page.team.eyebrow": "The People",
    "page.team.title": "A small firm of long-tenured principals.",
    "page.team.lede": "Bonworld's partners have spent their careers advising families whose interests span borders, generations and industries. Our team is small by design — we grow only when a specific mandate requires it.",

    "page.contact.eyebrow": "A Private Conversation",
    "page.contact.title": "By appointment only.",
    "page.contact.lede": "Bonworld does not accept unsolicited business. Every relationship begins with an introduction. If you believe our office may serve your family, please write to us.",

    "page.insights.eyebrow": "Journal · Insights",
    "page.insights.title": "Notes from the office.",
    "page.insights.lede": "Occasional writing on capital, governance and legacy — for the families we serve and the peers we respect.",
    "insights.readMore": "Read essay",
    "insights.back": "Back to Journal",
    "insights.published": "Published",

    "page.portal.eyebrow": "Private · Client Portal",
    "page.portal.title": "A discreet portal, for existing families.",
    "page.portal.lede": "Our secure client environment is currently accessible on invitation via encrypted channel. If you are a Bonworld principal or authorised advisor, please contact your relationship partner directly.",

    "page.imprint.eyebrow": "Legal · Imprint",
    "page.imprint.title": "Imprint & Legal Notices",
    "page.imprint.lede": "Information provided in accordance with applicable transparency and consumer disclosure requirements.",

    "page.privacy.eyebrow": "Legal · Privacy",
    "page.privacy.title": "Privacy Policy",
    "page.privacy.lede": "Bonworld's handling of personal data follows the Personal Data Protection Act of Singapore and, where applicable, comparable frameworks in the jurisdictions of the families we serve.",

    "page.cookies.eyebrow": "Legal · Cookies",
    "page.cookies.title": "Cookies Policy",
    "page.cookies.lede": "This site uses a minimum of cookies, in keeping with our preference for discretion and restraint.",

    "contact.name": "Full name",
    "contact.email": "Email",
    "contact.phone": "Phone (optional)",
    "contact.subject": "Subject",
    "contact.message": "Message",
    "contact.namePlace": "Your name",
    "contact.subjectPlace": "Nature of enquiry",
    "contact.messagePlace": "Please share, in confidence, what brings you to us.",
    "contact.send": "Send Message",
    "contact.sending": "Sending…",
    "contact.consent": "By submitting, you consent to Bonworld handling your details in accordance with our Privacy Policy.",
    "contact.receivedEyebrow": "Received",
    "contact.thankyou": "Thank you.",
    "contact.thankyouLede": "Your message has reached the office. A partner will be in touch within two business days, in confidence.",
    "contact.sendAnother": "Send another message",
    "contact.errorRequired": "Please provide your name, email and message.",
    "contact.errorGeneric": "Unable to submit. Please try again.",
    "contact.successToast": "Your message has been received. We will respond in confidence.",
  },

  de: {
    "nav.home": "Startseite",
    "nav.about": "Über uns",
    "nav.philosophy": "Philosophie",
    "nav.services": "Dienstleistungen",
    "nav.team": "Team",
    "nav.insights": "Journal",
    "nav.contact": "Kontakt",
    "nav.portal": "Kundenportal",
    "nav.cta": "Vertrauliches Gespräch",

    "home.eyebrow": "Singapur · Gegründet 2022 · UEN 202213354N",
    "home.headline1": "Vermögen bewahren",
    "home.headline2": "über Generationen hinweg.",
    "home.sublinePre": "Bonworld ist ein privates, ausschliesslich auf Einladung tätiges Family Office mit Sitz im Peninsula Plaza, Singapur. Seit 2022 betreuen wir das Mandat einer sehr kleinen Zahl von Prinzipalfamilien und verwalten über ",
    "home.sublinePost": " an beratenem Kapital – mit der Geduld eines Erben, nicht der Ungeduld eines Verwalters.",
    "home.aum": "SGD 2,1 Milliarden",
    "home.cta1": "Vorstellung anfragen",
    "home.cta2": "Unsere Philosophie",
    "home.badgeLeft": "111 North Bridge Road · #15-02",
    "home.badgeRight": "Für die Wenigen · Nicht für die Vielen",

    "home.stat0Val": "SGD 2,1 Mrd.+",
    "home.stat0Label": "Beratenes Familienvermögen unter Betreuung",
    "home.stat1Val": "12",
    "home.stat1Label": "Prinzipalfamilien auf drei Kontinenten",
    "home.stat2Val": "2022",
    "home.stat2Label": "Gründungsjahr in Singapur",
    "home.stat3Val": "8",
    "home.stat3Label": "Partner und leitende Fachleute",

    "home.pillarsEyebrow": "Vier Säulen",
    "home.pillarsTitle": "Die stille Architektur nachhaltigen Vermögens.",
    "home.pillarsLede": "Wir jagen keinen Indizes hinterher. Wir verkaufen keine Produkte. Unser Handwerk ist der koordinierte Einsatz von Kapital, Struktur und Beratung – über Jahrzehnte, nicht Quartale.",
    "home.pillar1Title": "Erhalt",
    "home.pillar1Text": "Kapitalschutz steht an erster Stelle. Volatilität wird gesteuert, Kursverluste begrenzt und die generationsübergreifende Kaufkraft gewahrt.",
    "home.pillar2Title": "Richtung",
    "home.pillar2Text": "Ein einziger, disziplinierter Anlageausschuss steuert einen kohärenten Kurs über öffentliche Märkte, Privatanlagen und Immobilien.",
    "home.pillar3Title": "Governance",
    "home.pillar3Text": "Strukturen, Stiftungen und Familienverfassungen, konzipiert für Kontinuität – stille Architektur, die Zyklen überdauert.",
    "home.pillar4Title": "Familie",
    "home.pillar4Text": "Wir dienen den menschlichen Ambitionen hinter dem Vermögen: Ausbildung der Erben, Philanthropie und Vermächtnis in seiner wahrsten Form.",

    "home.networkEyebrow": "Depot- & Managernetzwerk",
    "home.networkTitle": "Institutionelle Beziehungen hinter jeder Allokation.",
    "home.networkLede": "Bonworld arbeitet mit offener Architektur. Vermögenswerte werden bei erstklassigen Depotstellen im Namen der Familie gehalten; Kapital wird bei institutionellen Managern zu institutionellen Konditionen investiert.",

    "home.noteEyebrow": "Anmerkung",
    "home.quote": "Ein Family Office misst sich nicht an der Rendite des vergangenen Jahres, sondern an der Familie, die es in drei Generationen hinterlässt.",
    "home.quoteAttrib": "— Gründungscharta, Bonworld · Singapur · 2022",

    "home.ctaEyebrow": "Ein Gespräch",
    "home.ctaTitle": "Sollte Ihre Familie ein eigenes Office erwägen, wäre es uns eine Ehre, Sie kennenzulernen.",
    "home.ctaBtn": "Vertrauliches Treffen anfragen",

    "footer.tagline": "Ein Family Office für eine Familie, über mehrere Generationen – für einen ausgewählten Kreis von Prinzipalfamilien.",
    "footer.uenLine": "UEN 202213354N · Gegründet 2022",
    "footer.office": "Büro",
    "footer.byAppointment": "Ausschliesslich nach Terminvereinbarung",
    "footer.navigate": "Navigation",
    "footer.legal": "Rechtliches",
    "footer.motto": "Diskretion · Verantwortung · Kontinuität",
    "footer.rights": "Alle Rechte vorbehalten.",

    "cookie.eyebrow": "Hinweis zu Cookies",
    "cookie.text": "Wir verwenden nur ein Minimum an Cookies, um diese Website sicher zu halten und ihren Zustand zu überwachen. Keine Werbung. Kein seitenübergreifendes Tracking. Siehe unsere",
    "cookie.link": "Cookie-Richtlinie",
    "cookie.accept": "Akzeptieren",
    "cookie.essential": "Nur essenzielle",

    "page.about.eyebrow": "Über das Haus",
    "page.about.title": "Ein Haus für den langen Horizont.",
    "page.about.lede": "Gegründet 2022 in Singapur, wurde Bonworld auf einer einzigen Überzeugung errichtet: Der beste Verwalter des Familienvermögens ist eine Firma, die einzig dieser Familie verpflichtet ist. Unser Mandat ist bewusst schmal und diszipliniert tief.",

    "page.philosophy.eyebrow": "Anlagephilosophie",
    "page.philosophy.title": "Wie wir denken, bevor wir investieren.",
    "page.philosophy.lede": "Unsere Philosophie ist ein Bekenntnis – sechs Grundsätze, die jeder Portfolio-Entscheidung vorausgehen und jede folgende Entscheidung leiten.",

    "page.services.eyebrow": "Dienstleistungen",
    "page.services.title": "Ein einziges Mandat. Sechs koordinierte Disziplinen.",
    "page.services.lede": "Wir verkaufen keine Module. Wir bieten eine integrierte Dienstleistung – das Family Office – ausgedrückt durch sechs sich gegenseitig stärkende Disziplinen.",

    "page.team.eyebrow": "Die Menschen",
    "page.team.title": "Eine kleine Firma langjähriger Prinzipale.",
    "page.team.lede": "Die Partner von Bonworld haben ihre Karrieren der Beratung von Familien mit grenzüberschreitenden, generationsübergreifenden Interessen gewidmet. Unser Team ist bewusst klein – wir wachsen nur, wenn ein Mandat es erfordert.",

    "page.contact.eyebrow": "Ein Vertrauliches Gespräch",
    "page.contact.title": "Ausschliesslich nach Terminvereinbarung.",
    "page.contact.lede": "Bonworld nimmt keine unaufgefordert angebotenen Mandate an. Jede Beziehung beginnt mit einer Vorstellung. Wenn Sie glauben, dass unser Office Ihrer Familie dienen kann, schreiben Sie uns.",

    "page.insights.eyebrow": "Journal · Einblicke",
    "page.insights.title": "Notizen aus dem Office.",
    "page.insights.lede": "Gelegentliche Schriften zu Kapital, Governance und Vermächtnis – für die Familien, die wir betreuen, und die Kollegen, die wir schätzen.",
    "insights.readMore": "Essay lesen",
    "insights.back": "Zurück zum Journal",
    "insights.published": "Veröffentlicht",

    "page.portal.eyebrow": "Privat · Kundenportal",
    "page.portal.title": "Ein diskretes Portal für bestehende Familien.",
    "page.portal.lede": "Unsere sichere Kundenumgebung ist derzeit nur auf Einladung über einen verschlüsselten Kanal zugänglich. Wenn Sie ein Bonworld-Prinzipal oder autorisierter Berater sind, wenden Sie sich bitte direkt an Ihren Beziehungspartner.",

    "page.imprint.eyebrow": "Rechtliches · Impressum",
    "page.imprint.title": "Impressum & Rechtliche Hinweise",
    "page.imprint.lede": "Angaben gemäss geltenden Transparenz- und Offenlegungspflichten.",

    "page.privacy.eyebrow": "Rechtliches · Datenschutz",
    "page.privacy.title": "Datenschutzerklärung",
    "page.privacy.lede": "Der Umgang von Bonworld mit personenbezogenen Daten folgt dem Personal Data Protection Act von Singapur und, wo anwendbar, vergleichbaren Regelwerken.",

    "page.cookies.eyebrow": "Rechtliches · Cookies",
    "page.cookies.title": "Cookie-Richtlinie",
    "page.cookies.lede": "Diese Website verwendet ein Minimum an Cookies – im Einklang mit unserer Präferenz für Diskretion und Zurückhaltung.",

    "contact.name": "Vollständiger Name",
    "contact.email": "E-Mail",
    "contact.phone": "Telefon (optional)",
    "contact.subject": "Betreff",
    "contact.message": "Nachricht",
    "contact.namePlace": "Ihr Name",
    "contact.subjectPlace": "Art der Anfrage",
    "contact.messagePlace": "Bitte teilen Sie vertraulich mit, was Sie zu uns führt.",
    "contact.send": "Nachricht senden",
    "contact.sending": "Wird gesendet…",
    "contact.consent": "Mit dem Absenden willigen Sie ein, dass Bonworld Ihre Angaben gemäss Datenschutzerklärung verarbeitet.",
    "contact.receivedEyebrow": "Erhalten",
    "contact.thankyou": "Vielen Dank.",
    "contact.thankyouLede": "Ihre Nachricht ist im Office eingegangen. Ein Partner wird sich innerhalb von zwei Werktagen vertraulich melden.",
    "contact.sendAnother": "Weitere Nachricht senden",
    "contact.errorRequired": "Bitte geben Sie Namen, E-Mail und Nachricht an.",
    "contact.errorGeneric": "Übermittlung nicht möglich. Bitte erneut versuchen.",
    "contact.successToast": "Ihre Nachricht wurde empfangen. Wir antworten vertraulich.",
  },

  fr: {
    "nav.home": "Accueil",
    "nav.about": "À propos",
    "nav.philosophy": "Philosophie",
    "nav.services": "Services",
    "nav.team": "Équipe",
    "nav.insights": "Journal",
    "nav.contact": "Contact",
    "nav.portal": "Espace client",
    "nav.cta": "Entretien privé",

    "home.eyebrow": "Singapour · Fondé en 2022 · UEN 202213354N",
    "home.headline1": "Préserver le patrimoine",
    "home.headline2": "à travers les générations.",
    "home.sublinePre": "Bonworld est un family office privé, sur invitation, dont le siège se trouve au Peninsula Plaza, Singapour. Depuis 2022, nous détenons le mandat d'un très petit nombre de familles principales — administrant plus de ",
    "home.sublinePost": " de capital conseillé, avec la patience d'un héritier plutôt que l'impatience d'un gestionnaire.",
    "home.aum": "2,1 milliards SGD",
    "home.cta1": "Demander une introduction",
    "home.cta2": "Notre philosophie",
    "home.badgeLeft": "111 North Bridge Road · #15-02",
    "home.badgeRight": "Établi pour les rares · Non pour la multitude",

    "home.stat0Val": "SGD 2,1 Md+",
    "home.stat0Label": "Capital familial conseillé sous gérance",
    "home.stat1Val": "12",
    "home.stat1Label": "Familles principales sur trois continents",
    "home.stat2Val": "2022",
    "home.stat2Label": "Année de fondation à Singapour",
    "home.stat3Val": "8",
    "home.stat3Label": "Associés et professionnels seniors",

    "home.pillarsEyebrow": "Quatre piliers",
    "home.pillarsTitle": "L'architecture silencieuse d'un patrimoine durable.",
    "home.pillarsLede": "Nous ne courons pas après les indices. Nous ne vendons pas de produits. Notre métier est le déploiement coordonné de capital, de structure et de conseil — sur des décennies, non des trimestres.",
    "home.pillar1Title": "Préservation",
    "home.pillar1Text": "La défense du capital est le premier mandat. La volatilité est gérée, les pertes contenues, et le pouvoir d'achat générationnel préservé.",
    "home.pillar2Title": "Direction",
    "home.pillar2Text": "Un comité d'investissement unique et discipliné trace un cap cohérent sur les marchés publics, les actifs privés et l'immobilier.",
    "home.pillar3Title": "Gouvernance",
    "home.pillar3Text": "Structures, trusts et chartes familiales pensés pour la continuité — architecture silencieuse qui traverse les cycles.",
    "home.pillar4Title": "Famille",
    "home.pillar4Text": "Nous servons les ambitions humaines derrière le patrimoine : éducation des héritiers, philanthropie et héritage au sens le plus vrai.",

    "home.networkEyebrow": "Réseau de dépositaires et de gérants",
    "home.networkTitle": "Des relations institutionnelles derrière chaque allocation.",
    "home.networkLede": "Bonworld fonctionne en architecture ouverte. Les actifs sont détenus chez des dépositaires de premier plan au nom de la famille ; le capital est déployé auprès de gérants institutionnels à conditions institutionnelles.",

    "home.noteEyebrow": "Note",
    "home.quote": "Un family office ne se mesure pas au rendement délivré l'an passé, mais à la famille qu'il livre trois générations plus tard.",
    "home.quoteAttrib": "— Charte fondatrice, Bonworld · Singapour · 2022",

    "home.ctaEyebrow": "Un entretien",
    "home.ctaTitle": "Si votre famille envisage un office dédié, nous aurions l'honneur de vous rencontrer.",
    "home.ctaBtn": "Demander un entretien privé",

    "footer.tagline": "Un office familial, multi-générationnel, dédié à la gérance du capital, de la gouvernance et de l'héritage d'un cercle restreint de familles principales.",
    "footer.uenLine": "UEN 202213354N · Fondé en 2022",
    "footer.office": "Bureau",
    "footer.byAppointment": "Uniquement sur rendez-vous",
    "footer.navigate": "Navigation",
    "footer.legal": "Mentions",
    "footer.motto": "Discrétion · Gérance · Continuité",
    "footer.rights": "Tous droits réservés.",

    "cookie.eyebrow": "À propos des cookies",
    "cookie.text": "Nous utilisons un minimum de cookies pour sécuriser ce site et en surveiller la santé. Aucune publicité. Aucun suivi inter-sites. Voir notre",
    "cookie.link": "Politique des cookies",
    "cookie.accept": "Accepter",
    "cookie.essential": "Essentiels uniquement",

    "page.about.eyebrow": "À propos de la maison",
    "page.about.title": "Une maison bâtie pour le long terme.",
    "page.about.lede": "Fondée à Singapour en 2022, Bonworld repose sur une seule conviction : le meilleur gérant du capital d'une famille est une firme qui ne répond qu'à cette famille. Notre mandat est étroit par choix et profond par discipline.",

    "page.philosophy.eyebrow": "Philosophie d'investissement",
    "page.philosophy.title": "Comment nous pensons, avant comment nous investissons.",
    "page.philosophy.lede": "Notre philosophie est un engagement — six principes qui précèdent toute décision de portefeuille et qui régissent toutes celles qui suivent.",

    "page.services.eyebrow": "Services",
    "page.services.title": "Un mandat unique. Six disciplines coordonnées.",
    "page.services.lede": "Nous ne vendons pas de modules. Nous offrons un service intégré — le family office — exprimé à travers six disciplines qui se renforcent mutuellement.",

    "page.team.eyebrow": "Les gens",
    "page.team.title": "Une petite firme d'associés au long cours.",
    "page.team.lede": "Les associés de Bonworld ont consacré leur carrière au conseil de familles dont les intérêts traversent frontières, générations et industries. Notre équipe est petite par nature — nous ne grandissons que lorsqu'un mandat l'exige.",

    "page.contact.eyebrow": "Un entretien privé",
    "page.contact.title": "Uniquement sur rendez-vous.",
    "page.contact.lede": "Bonworld n'accepte pas les sollicitations spontanées. Toute relation commence par une introduction. Si vous pensez que notre office peut servir votre famille, écrivez-nous.",

    "page.insights.eyebrow": "Journal · Perspectives",
    "page.insights.title": "Notes de la maison.",
    "page.insights.lede": "Écrits occasionnels sur le capital, la gouvernance et l'héritage — pour les familles que nous servons et les pairs que nous respectons.",
    "insights.readMore": "Lire l'essai",
    "insights.back": "Retour au Journal",
    "insights.published": "Publié",

    "page.portal.eyebrow": "Privé · Espace client",
    "page.portal.title": "Un portail discret, pour les familles existantes.",
    "page.portal.lede": "Notre environnement client sécurisé n'est actuellement accessible que sur invitation via un canal chiffré. Si vous êtes un principal Bonworld ou un conseiller autorisé, veuillez contacter directement votre associé référent.",

    "page.imprint.eyebrow": "Mentions · Imprint",
    "page.imprint.title": "Mentions légales",
    "page.imprint.lede": "Informations fournies conformément aux exigences de transparence et d'information applicables.",

    "page.privacy.eyebrow": "Mentions · Confidentialité",
    "page.privacy.title": "Politique de confidentialité",
    "page.privacy.lede": "Le traitement des données personnelles par Bonworld suit le Personal Data Protection Act de Singapour et, le cas échéant, les cadres comparables des juridictions des familles servies.",

    "page.cookies.eyebrow": "Mentions · Cookies",
    "page.cookies.title": "Politique des cookies",
    "page.cookies.lede": "Ce site utilise un minimum de cookies, conforme à notre préférence pour la discrétion et la retenue.",

    "contact.name": "Nom complet",
    "contact.email": "E-mail",
    "contact.phone": "Téléphone (facultatif)",
    "contact.subject": "Objet",
    "contact.message": "Message",
    "contact.namePlace": "Votre nom",
    "contact.subjectPlace": "Nature de la demande",
    "contact.messagePlace": "Partagez-nous, en toute confidentialité, ce qui vous amène.",
    "contact.send": "Envoyer le message",
    "contact.sending": "Envoi…",
    "contact.consent": "En soumettant, vous consentez à ce que Bonworld traite vos informations selon notre Politique de confidentialité.",
    "contact.receivedEyebrow": "Reçu",
    "contact.thankyou": "Merci.",
    "contact.thankyouLede": "Votre message a bien atteint le bureau. Un associé vous contactera sous deux jours ouvrés, en toute confidentialité.",
    "contact.sendAnother": "Envoyer un autre message",
    "contact.errorRequired": "Veuillez indiquer votre nom, votre e-mail et votre message.",
    "contact.errorGeneric": "Envoi impossible. Veuillez réessayer.",
    "contact.successToast": "Votre message a été reçu. Nous répondrons en toute confidentialité.",
  },

  zh: {
    "nav.home": "首页",
    "nav.about": "关于",
    "nav.philosophy": "投资理念",
    "nav.services": "服务",
    "nav.team": "团队",
    "nav.insights": "见解",
    "nav.contact": "联系",
    "nav.portal": "客户专区",
    "nav.cta": "私人咨询",

    "home.eyebrow": "新加坡 · 成立于 2022 · UEN 202213354N",
    "home.headline1": "守护财富",
    "home.headline2": "跨越世代。",
    "home.sublinePre": "邦沃德是一家总部位于新加坡半岛广场、仅接受邀请的私人家族办公室。自 2022 年以来，我们为极少数主要家族提供受托服务，管理超过 ",
    "home.sublinePost": " 的顾问资产 — 以继承人的耐心，而非管理者的急迫。",
    "home.aum": "21 亿新元",
    "home.cta1": "申请引荐",
    "home.cta2": "我们的理念",
    "home.badgeLeft": "北桥路 111 号 · #15-02",
    "home.badgeRight": "为少数所设 · 不为多数",

    "home.stat0Val": "21 亿新元+",
    "home.stat0Label": "受托管理的家族资本",
    "home.stat1Val": "12",
    "home.stat1Label": "横跨三大洲的主要家族",
    "home.stat2Val": "2022",
    "home.stat2Label": "于新加坡成立之年",
    "home.stat3Val": "8",
    "home.stat3Label": "合伙人及资深专业人员",

    "home.pillarsEyebrow": "四大支柱",
    "home.pillarsTitle": "恒久财富的静谧架构。",
    "home.pillarsLede": "我们不追逐指数，不销售产品。我们的技艺在于协调部署资本、架构与咨询 — 以数十年为尺度，而非季度。",
    "home.pillar1Title": "保全",
    "home.pillar1Text": "资本防护是首要使命。波动受管理，回撤被约束，世代购买力得以守护。",
    "home.pillar2Title": "方向",
    "home.pillar2Text": "单一而严谨的投资委员会，跨公开市场、私募资产与不动产订立连贯航向。",
    "home.pillar3Title": "治理",
    "home.pillar3Text": "为延续而设计的架构、信托与家族章程 — 静谧的架构，穿越周期。",
    "home.pillar4Title": "家族",
    "home.pillar4Text": "我们服务于财富背后的人文抱负：继承人的教育、慈善事业与真正意义的传承。",

    "home.networkEyebrow": "托管与管理人网络",
    "home.networkTitle": "每一次配置背后的机构级关系。",
    "home.networkLede": "邦沃德采用开放架构。资产以家族名义存放于一流托管机构；资本以机构条款配置于机构级管理人。",

    "home.noteEyebrow": "手记",
    "home.quote": "衡量家族办公室，不是去年交付的回报，而是三代之后交付的家族。",
    "home.quoteAttrib": "— 邦沃德创立宪章 · 新加坡 · 2022",

    "home.ctaEyebrow": "对话",
    "home.ctaTitle": "若贵家族正考虑设立专属办公室，我们将深感荣幸与您会面。",
    "home.ctaBtn": "预约私人会面",

    "footer.tagline": "一家单一家族、多代际服务的办公室，为一小群主要家族守护资本、治理与传承。",
    "footer.uenLine": "UEN 202213354N · 成立于 2022",
    "footer.office": "办公室",
    "footer.byAppointment": "仅限预约",
    "footer.navigate": "导航",
    "footer.legal": "法律",
    "footer.motto": "审慎 · 受托 · 延续",
    "footer.rights": "版权所有。",

    "cookie.eyebrow": "关于 Cookie",
    "cookie.text": "我们仅使用极少量 Cookie 以保障本网站的安全与运行状态。无广告，无跨站追踪。详见我们的",
    "cookie.link": "Cookie 政策",
    "cookie.accept": "接受",
    "cookie.essential": "仅必要项",

    "page.about.eyebrow": "关于本府",
    "page.about.title": "为长远而建的一所家族之府。",
    "page.about.lede": "邦沃德于 2022 年在新加坡成立，源于一个坚定的信念：最好的家族资本受托人，是一家仅对该家族负责的机构。我们的授权本质精简，纪律深厚。",

    "page.philosophy.eyebrow": "投资理念",
    "page.philosophy.title": "先明思路，再谈投资。",
    "page.philosophy.lede": "我们的理念是一份契约 — 六项原则，先于任何投资决定，并统摄其后每一次决策。",

    "page.services.eyebrow": "服务",
    "page.services.title": "单一使命。六项协同的功能。",
    "page.services.lede": "我们不销售模块。我们提供一项完整服务 — 家族办公室 — 以六项相辅相成的功能呈现。",

    "page.team.eyebrow": "我们的人",
    "page.team.title": "一群长期共事的核心专业人员。",
    "page.team.lede": "邦沃德的合伙人一生都在为跨越国界、代际与产业的家族提供咨询。我们的团队本就精简 — 仅在特定授权需要时方才增长。",

    "page.contact.eyebrow": "一次私密的对话",
    "page.contact.title": "仅限预约。",
    "page.contact.lede": "邦沃德不接受主动招揽的业务。每一段关系都始于一次引荐。若您认为我们的办公室可为贵家族服务，请与我们联系。",

    "page.insights.eyebrow": "见解 · 期刊",
    "page.insights.title": "来自办公室的手记。",
    "page.insights.lede": "关于资本、治理与传承的偶尔文字 — 献给我们服务的家族，与我们尊敬的同侪。",
    "insights.readMore": "阅读全文",
    "insights.back": "返回期刊",
    "insights.published": "发布于",

    "page.portal.eyebrow": "私密 · 客户专区",
    "page.portal.title": "为现有家族而设的审慎门户。",
    "page.portal.lede": "我们的安全客户环境目前仅通过加密渠道以邀请方式开放。若您是邦沃德的委托人或授权顾问，请直接联系您的关系合伙人。",

    "page.imprint.eyebrow": "法律 · 版权",
    "page.imprint.title": "版权声明与法律信息",
    "page.imprint.lede": "依据适用的透明度与信息披露要求所载之信息。",

    "page.privacy.eyebrow": "法律 · 隐私",
    "page.privacy.title": "隐私政策",
    "page.privacy.lede": "邦沃德对个人数据的处理遵循新加坡《个人资料保护法》及适用的可比司法框架。",

    "page.cookies.eyebrow": "法律 · Cookie",
    "page.cookies.title": "Cookie 政策",
    "page.cookies.lede": "本网站仅使用极少量 Cookie，与我们审慎、克制的偏好一致。",

    "contact.name": "姓名",
    "contact.email": "电子邮箱",
    "contact.phone": "电话（可选）",
    "contact.subject": "主题",
    "contact.message": "信息",
    "contact.namePlace": "您的姓名",
    "contact.subjectPlace": "咨询性质",
    "contact.messagePlace": "请以保密方式告知您此次联系的缘由。",
    "contact.send": "发送信息",
    "contact.sending": "发送中…",
    "contact.consent": "提交即表示您同意邦沃德按照隐私政策处理您的信息。",
    "contact.receivedEyebrow": "已收到",
    "contact.thankyou": "谢谢您。",
    "contact.thankyouLede": "您的信息已送达办公室。合伙人将在两个工作日内以保密方式与您联系。",
    "contact.sendAnother": "再发一封",
    "contact.errorRequired": "请填写姓名、邮箱与信息。",
    "contact.errorGeneric": "提交失败，请稍后再试。",
    "contact.successToast": "已收到您的信息。我们将以保密方式回复。",
  },
};

export const DEFAULT_LANG = "en";
